// Postagens exibidas na home pelo incorporador oficial do Instagram. A foto, o vídeo
// e o perfil vêm direto do Instagram; se a pessoa apagar a postagem, ela some daqui também.
// Antes de incluir, confira se o vídeo toca no site: quando o Instagram bloqueia a
// reprodução externa, o player mostra só a capa esticada e "Assistir no Instagram".
export const instagramPosts = [
  { url: "https://www.instagram.com/p/DefYIpwpJMj/", author: "whoiscarolrangel" },
  { url: "https://www.instagram.com/p/DcGcbZIxB6R/", author: "empresariosdamoda" },
  { url: "https://www.instagram.com/p/Ddhh3EvxPHv/", author: "amandabrasoficial" },
  { url: "https://www.instagram.com/p/DemQ_dmIJhZ/", author: "bozzettistore" },
];
